import { IResource } from "@gettactic/api";
import { Modal } from "@/ui/index";
import { DeleteResource } from "@/features/settings/components/DeleteResource";

export interface DeleteResourceModalProps {
  deleteModal: IResource[];
  setDeleteModal: React.Dispatch<React.SetStateAction<IResource[]>>;
  setSideDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DeleteResourceModal = ({
  deleteModal,
  setDeleteModal,
  setSideDrawerOpen
}: DeleteResourceModalProps) => {
  return (
    <Modal
      title="Confirm Action"
      isOpen={deleteModal.length > 0}
      onClose={() => setDeleteModal([])}
      size="sm"
    >
      {deleteModal ? (
        <DeleteResource
          key={deleteModal.map((x) => x.id).join(",")}
          onClose={() => setDeleteModal([])}
          resources={deleteModal}
          setSideDrawerOpen={setSideDrawerOpen}
        />
      ) : null}
    </Modal>
  );
};
